import { render, staticRenderFns } from "./page-history.vue?vue&type=template&id=3643148a&scoped=true"
import script from "./page-history.vue?vue&type=script&lang=js"
export * from "./page-history.vue?vue&type=script&lang=js"
import style0 from "./page-history.vue?vue&type=style&index=0&id=3643148a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643148a",
  null
  
)

export default component.exports